import SideNav from "../components/sideNav"
import TopNav from "../components/topNav"
import AppContent from "./AppContent"
import { Navigate } from 'react-router-dom'
import { useEffect, useState } from 'react'



const DefaultLayout = () => {
  const [loading, setLoading] = useState(true)
  const [token, setToken] = useState<any>(null)
  const [isSideNavOpen, setIsSideNavOpen] = useState(false)

  const handleToggleSideNav = () => {
    setIsSideNavOpen((prev) => !prev)
  }

  const handleCloseSideNav = () => {
    setIsSideNavOpen(false)
  }



  useEffect(() => {
    setToken(sessionStorage.getItem('authToken'));
    setLoading(false);
  }, []);

  if (loading) {
    return <>loading....</>
  }

  if (!token) {
    return <Navigate to='/login' />
  }
  return (
    <div className="root-container">
      <div className="root-container__side-nav">
        <SideNav isOpen={isSideNavOpen} onClose={handleCloseSideNav} />
      </div>
      <div className="root-container__body">
        <div className="top-nav">
          <TopNav onToggleSideNav={handleToggleSideNav} />
        </div>
        <div className="content">
          <AppContent />
        </div>
      </div>
    </div>
  )
}
export default DefaultLayout